import { Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import {
  DeviceConnectedLogo,
  DeviceDisconnectedLogo,
} from "../../../../Logo/logos";
import { BatteryIcon } from "../../../../icons/StatusIcons";

const FlowDevice = ({
  title,
  deviceId,
  deviceStatus,
  flowValue,
  totalFlowValue,
  lastUpdated,
  powerStatus,
}) => {
  // Check if this is an expired subscription message
  const isExpiredSubscription = flowValue === "Subscription Expired";

  return (
    <div
      style={{
        backgroundImage:
          deviceStatus === "active"
            ? "url(/images/flow.gif)"
            : "url(/images/flow.png)",
      }}
      className="device-card-flow"
    >
      <div className="device-card-head">
        <Tooltip title={title || ""} placement="top">
          <Link to={`/device-detail/${deviceId}`} style={{ textDecoration: "none" }}>
            <div className="device-card-title">
              {title}
            </div>
          </Link>
        </Tooltip>
        <div className="device-card-status">
          <>
            {!isExpiredSubscription && (
              deviceStatus === "active" ? (
                <Tooltip title="Device Connected">
                  <DeviceConnectedLogo />
                </Tooltip>
              ) : (
                <Tooltip title="Device Disconnected">
                  <DeviceDisconnectedLogo />
                </Tooltip>
              )
            )}
            {!isExpiredSubscription && (
              <Tooltip title={powerStatus == null ? "Power status unavailable" : Number(powerStatus) === 1 ? "Power On" : "Power Off"}>
                <BatteryIcon on={powerStatus == null ? null : Number(powerStatus) === 1} />
              </Tooltip>
            )}
          </>
        </div>
      </div>
      <div className="device-card-metrics">
        <div className="device-card-metric">
          {isExpiredSubscription ? (
            <div className="device-card-expired">
              {flowValue}
            </div>
          ) : (
            <>
              <div className="device-card-metric-label">Flow:</div>
              <div className="device-card-metric-value">{flowValue}</div>
            </>
          )}
        </div>
        {!isExpiredSubscription && (
          <div className="device-card-metric">
            <div className="device-card-metric-label">Totalizer:</div>
            <div className="device-card-metric-value">{totalFlowValue}</div>
          </div>
        )}
      </div>
      {!isExpiredSubscription && (
        <div className="device-card-updated">
          <div className="device-card-metric">
            <div className="device-card-metric-label">Last Updated:</div>
            <div className="device-card-metric-value device-card-metric-stamp">
              {lastUpdated}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FlowDevice;
